import { CircularProgress } from "@mui/material";
import React from "react";
import getNPSData from "../api";
import NpsComponent from "./nps";
import ThankComponent from "./thank";

const extractShortcode = () => {
    const path = window.location.pathname || "";
    const pathShortcode = path.split("/").filter(Boolean)[0] || null;
    const queryParam = new URLSearchParams(window.location.search);
    return queryParam.get("shortcode") || pathShortcode || null;
};

function NPS() {
    const [npsObject, setNPSObject] = React.useState(null);
    const [update, setUpdate] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    React.useEffect(() => {
        const func = async () => {
            setLoading(true);

            const shortcode = extractShortcode();

            if (!shortcode) {
                setError("Link inválido: shortcode não informado.");
                setLoading(false);
                return;
            }

            const data = await getNPSData({ shortcode });
            if (!data) {
                setError("Este questionário não está mais disponível.");
            } else {
                setNPSObject(data);
            }

            setTimeout(() => {
                setLoading(false);
            }, 600);
        };
        func();
    }, [update]);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <CircularProgress size={80} style={{ color: "#182642" }} />
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", margin:32 }}>
                <p>{error}</p>
            </div>
        );
    }

    const isAlreadyAnswered =
        npsObject &&
        (npsObject.answered ||
            npsObject.status === `already ansewered` ||
            npsObject.status === `already answered`);

    return (
        <div>
            {isAlreadyAnswered ? (
                <ThankComponent npsInfo={npsObject} />
            ) : (
                <NpsComponent npsInfo={npsObject} onNpsAnswered={() => setUpdate(update + 1)} />
            )}
        </div>
    );
}

export default NPS;
